import type { ContentEntity, ParagraphForm } from "~/types/drupal_jsonapi";

export function nodeHasInPageForm(
  node: ContentEntity & { field_form: ParagraphForm },
) {
  return node.field_form && node.field_form.field_display;
}
